<template>
<div class="rate-star">
  <img class="rate-logo" src="/image/tripadvisor.png">
  <div class="star-container">
    <img class="star" src="/image/empty_circle.svg">
    <div class="star-mask" :style="`width: ${rating * 100 / 5}%`">
      <img class="star" src="/image/full_circle.svg">
    </div>
  </div>
</div>
</template>

<script>
export default {
  props: {
    rating: {
      type: Number,
      default: 0
    }
  }
}
</script>

<style lang="scss" scoped>
.star-container {
  display: flex;
  align-items: center;
  position: relative;
  transform: translateY(1px);

  .star-mask {
    position: absolute;
    top: 0;
    left: 0;
    height: 100%;
    background-color: #ffffff;
    overflow: hidden;
    display: flex;
    align-items: center;
  }
}
.rate-star {
  display: flex;

  .rate-logo {
    width: 20px;
    height: 12px;
    margin-right: 4px;
    display: block;
  }

  .star {
    display: block;
    width: 40px;
    flex-shrink: 0;
    max-width: initial;
    max-height: initial;
  }
}
</style>
